export const ACCOUNT = 'ACCOUNT';

export const UPDATE_ACCOUNT = `${ACCOUNT}/UPDATE_ACCOUNT`;
export const UPDATE_ACCOUNT_FAILED = `${ACCOUNT}/UPDATE_ACCOUNT_FAILED`;